import * as tslib_1 from "tslib";
import { removeMasterCategories } from 'owa-categories';
import { isCategoryInFavorites, lazyRemoveFavoriteCategory } from 'owa-favorites';
import { action } from 'satcheljs/lib/legacy';
export default action('deleteCategoryRow')(function deleteCategoryRow(idToDelete, nameToDelete) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var removeFavoriteCategory;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isCategoryInFavorites(idToDelete)) return [3 /*break*/, 2];
                    return [4 /*yield*/, lazyRemoveFavoriteCategory.import()];
                case 1:
                    removeFavoriteCategory = _a.sent();
                    removeFavoriteCategory(idToDelete, 'CategoriesOptions');
                    _a.label = 2;
                case 2:
                    removeMasterCategories([nameToDelete], 'CategoriesOptions');
                    return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=deleteCategoryRow.js.map